import { httpClient } from "@/services";

export default {
	state: {
		equipmentList: [],
		equipmentFilter: null
	},
	mutations: {
		updateEquipmentList(state, { truck_equipment, filter }) {
			state.equipmentList = truck_equipment;
			state.equipmentFilter = filter;
		}
	},
	actions: {
		async onEquipmentList({ commit }, id) {
			try {
				const { data } = await httpClient.post(`/trucks/equipment/${ id }`);
				if (data && !data.status) {
					commit('updateEquipmentList', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onEquipmentListFilter({ commit }, { id, filters } ) {
			try {
				const { data } = await httpClient.post(`/trucks/equipment/${ id }/list`, filters);
				if (data && !data.status) {
					commit('updateEquipmentList', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onEquipmentCreate({ dispatch }, values) {
			const { id, truckId, ...obj } = values;
			const url = id ? `trucks/equipment/${ id }/update` : `trucks/equipment/${ truckId }/store`;
			const message = id ? "Updated equipment item" : "Created equipment item";
			const { data } = await httpClient.post(url, obj);

			if (data && data.status) {
				dispatch('setAlert', { type: "success", message });
				dispatch('onEquipmentList', truckId);
			}
		},
		async onEquipmentSelectItem({ dispatch }, name) {
			const { data } = await httpClient.post('trucks/setEquipment', { name });
			if (data && !data.status) {
				dispatch('setAlert', { type: "success", message: "Created select item" });
				return data.equipments;
			}
		},
		async onEquipmentEdit(context, id) {
			const { data } = await httpClient.get(`/trucks/equipment/${ id }/edit`);
			if (data && !data.status) {
				return data.truck_equipment[0];
			}
		},
		async onEquipmentRemove({ dispatch }, { id, truckId }) {
			const { data } = await httpClient.delete(`/trucks/equipment/${ id }`);

			if (data && data.status) {
				dispatch('setAlert', { type: "success", message: "Remove equipment item" });
				dispatch('onEquipmentList', truckId);
			}
		}
	},
	getters: {
		equipmentList: s => s.equipmentList,
		equipmentFilter: s => s.equipmentFilter,
	}
};
